// extracted by mini-css-extract-plugin
var _1 = "UserNotificationSettingsTable-module__animatedBackground--T6B6m";
var _2 = "UserNotificationSettingsTable-module__items--kUJTu";
var _3 = "UserNotificationSettingsTable-module__platformHeadings--VU2GU";
var _4 = "UserNotificationSettingsTable-module__scopeContainer--CcGon";
var _5 = "UserNotificationSettingsTable-module__toggleContainer--klcVs";
var _6 = "UserNotificationSettingsTable-module__toggles--SyLBP";
export { _1 as "animatedBackground", _2 as "items", _3 as "platformHeadings", _4 as "scopeContainer", _5 as "toggleContainer", _6 as "toggles" }
